<script lang="ts" setup>
import { DocumentViewMode } from "~/types/enums/DocumentViewMode.enum";

const props = defineProps({
  submittedDocument: {
    type: Object as PropType<SubmittedDocument>,
  },
  mode: {
    type: String as PropType<DocumentViewMode>,
    required: true,
  },
  isAutoReturnEnabled: {
    type: Boolean,
    default: true,
  },
  showViewButton: {
    type: Boolean,
    default: true,
  },
  filled: {
    type: Boolean,
    default: true,
  },
});

const isLate = computed(() => {
  return props.submittedDocument?.isLate;
});

const isDocumentReady = computed(() => {
  if (!props.submittedDocument) return false;

  return useIsDocumentReadyToGrade(props.submittedDocument);
});

const showGradedState = computed(() => {
  if (!props.submittedDocument) return false;

  if (props.mode == DocumentViewMode.student) {
    // If isAutoReturnEnabled != true ** the submitted document.isReturneToStudent is not true, then we do not want to show their gradd.
    if (
      props.isAutoReturnEnabled != true &&
      props.submittedDocument?.isReturnedToStudent != true
    ) {
      return false;
    }
  }

  return useShowDocumentGradedState(props.submittedDocument);
});

const showGrade = computed(() => {
  if (props.mode == DocumentViewMode.student) {
    // If isAutoReturnEnabled != true ** the submitted document.isReturneToStudent is not true, then we do not want to show their gradd.
    if (
      props.isAutoReturnEnabled != true &&
      props.submittedDocument?.isReturnedToStudent != true
    ) {
      return false;
    }
  }

  return (
    props.submittedDocument?.state == DocumentState.graded &&
    (props.submittedDocument.documentSubmissionType ??
      DocumentSubmissionType.finalDraft) == DocumentSubmissionType.finalDraft
  );
});
</script>

<template>
  <NuxtLink
    v-if="submittedDocument"
    class="flex flex-row justify-end items-center cursor-pointer w-full"
    target="_blank"
    :to="useGenerateDocumentPath(submittedDocument, mode, isAutoReturnEnabled)"
  >
    <span v-if="isLate" class="text-danger-default mr-4"> late </span>
    <NuxtLink
      v-if="
        showViewButton &&
        isDocumentReady &&
        useCanGradeDocument(submittedDocument, mode) &&
        useGenerateDocumentPath(submittedDocument, mode, isAutoReturnEnabled)
      "
      :to="
        useGenerateDocumentPath(submittedDocument, mode, isAutoReturnEnabled)
      "
      target="_blank"
      class="mr-4"
    >
      <BaseTextButton>View</BaseTextButton>
    </NuxtLink>

    <DocumentGradedStatePill
      v-if="showGradedState && submittedDocument?.documentGradedState"
      class="!w-[150px] mr-1"
      :document-graded-state="submittedDocument.documentGradedState"
    />
    <span
      v-if="
        showGradedState != true &&
        submittedDocument.state == DocumentState.graded &&
        showGrade == true &&
        submittedDocument.earnedPoints != undefined &&
        submittedDocument.maxPoints != undefined
      "
      class="h-[42px] w-[150px] p-2 border-2 bg-light-default rounded shrink-0 mr-1 text-center"
    >
      {{ submittedDocument.earnedPoints }} /
      {{ submittedDocument.maxPoints }} points
    </span>
    <DocumentStatePill
      :state="submittedDocument?.state ?? DocumentState.notImported"
      :filled="filled"
      :class="{
        '!cursor-not-allowed':
          useGenerateDocumentPath(
            submittedDocument,
            mode,
            isAutoReturnEnabled
          ) == undefined,
      }"
    />
  </NuxtLink>
</template>

<style scoped></style>
